<template>
    <minimal>
        <div class="text-center">
            <h1>{{useError().value.statusMessage}}</h1>
        </div>
    </minimal>
</template>

<script setup>
const Minimal = defineAsyncComponent(() => import('~/errors/minimal.vue'))

useHead({
    title: '401'
})
</script>
